import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import Button from "nx-components/Button";
import prefixStyles from "nx-components/utils/prefixStyles";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";
import DeviceControlButton from "nexia_mobile/components/Controls/DeviceControlButton";

const styles = prefixStyles({
  wrapper: {
    fontSize: "0.8em",
    display: "flex",
  },
  detailButtonOn: {
    marginRight: "0.25em",
    flexGrow: "1",
    flexBasis: "100%",
  },
  detailButtonOff: {
    marginLeft: "0.25em",
    flexGrow: "1",
    flexBasis: "100%",
  },
});

const Switch = ({ model, isDetailed, showSpinner, hideSpinner }) => {
  if (isDetailed && model.canSetOnAndOffSeparately()) {
    return (
      <CommonControlWrapper isDetailed={isDetailed}>
        <div style={styles.wrapper}>
          <Button
            style={styles.detailButtonOn}
            onTap={() => {
              showSpinner(`Turning on '${model.get("name")}'`);
              model.turnOn().then(hideSpinner, hideSpinner);
            }}
          >
            Turn On
          </Button>
          <Button
            style={styles.detailButtonOff}
            onTap={() => {
              showSpinner(`Turning off '${model.get("name")}'`);
              model.turnOff().then(hideSpinner, hideSpinner);
            }}
          >
            Turn Off
          </Button>
        </div>
      </CommonControlWrapper>
    );
  } else {
    return (
      <CommonControlWrapper isDetailed={isDetailed}>
        <DeviceControlButton
          buttonLabel={model.isOn() ? "Turn Off" : "Turn On"}
          onTap={() => {
            showSpinner(
              `Turning ${model.isOn() ? "off" : "on"} '${model.get("name")}'`
            );
            model.toggle().then(hideSpinner, hideSpinner);
          }}
        />
      </CommonControlWrapper>
    );
  }
};
Switch.propTypes = {
  model: PropTypes.instanceOf(Backbone.Model).isRequired,
  isDetailed: PropTypes.bool.isRequired,
  showSpinner: PropTypes.func.isRequired, // (?string) => void
  hideSpinner: PropTypes.func.isRequired, // () => void
};

export default Switch;



// WEBPACK FOOTER //
// ./src/components/Controls/Switch.jsx